import css from 'styled-jsx/css';

const styles = css.global`.modal-insurance-details {
  padding: calc(40px - 24px) 0;
}

.modal-insurance-details .text-title {
  color: #222;
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  margin: 0 0 32px;
}

.modal-insurance-details .sn-button.white {
  margin-top: 16px;
}

.modal-insurance-details .text-title-desk {
  display: none;
}

.modal-insurance-details .text-cover {
  color: #222;
  font-family: SantanderText;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  margin: 0;
}

.modal-insurance-details .benefit-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 16px;
}

.modal-insurance-details .benefit-text {
  color: #222;
  font-family: SantanderText;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  margin: 0;
}

.modal-insurance-details .benefit-row img {
  margin-top: 2px;
  width: 24px;
  height: auto;
  object-fit: contain;
}

.modal-insurance-details-header {
  height: 80px;
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  justify-content: stretch;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 9000;
  background-color: #fff;
  width: 100%;

  box-shadow: 0px 2px 8px -2px #2222221f;
}

.modal-insurance-details-header .ctn-home-24 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.modal-insurance-details-header p {
  color: #222;
  font-family: SantanderHeadline;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0%;
  padding: 0;
  margin: 0;
}

@media (min-width: 992px) {
  .modal-insurance-details-header {
    display: none;
  }

  .modal-insurance-details {
    padding: 0;
    height: 100%;
  }

  .modal-insurance-details .text-title-desk {
    display: block;
    max-width: calc(100% - 48px);
    color: #222;
    margin: 0;
    font-family: SantanderHeadline;
    font-weight: 400;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0%;
  }

  .modal-insurance-details .text-title {
    margin: 22px 0 32px;
  }

  .modal-insurance-details .ctn-home-24 {
    padding: 0 !important;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .modal-insurance-details .btn-wrapper {
    display: block;
    margin-top: auto;
  }

  .modal-insurance-details .info-box .text-desc {
    max-width: 224px;
  }

  .modal-insurance-details .sn-button.white {
    display: none !important;
  }
}
`;

export default styles;